// @flow

import React from 'react'
import {AriaHidden} from '../../shared/AriaHidden'
import {bem} from '../../shared/bem'
import {mandatfordelingTable__cell as cell} from './index.css'

import type {Element} from 'react'

type HeaderProps = {
  type: string,
  children?: ?Element<any>
}
export function Header(props: HeaderProps) {
  return (
    <div className={bem(cell, 'header', `header-${props.type}`)} key="h1">
      <AriaHidden>
        {props.children}
      </AriaHidden>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/mandatfordeling/MandatfordelingTable/header.js